var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from "styled-components";
var Root = styled.code(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: var(--brand-lightest);\n  padding: calc(var(--spacing) * 0.5) calc(var(--spacing));\n  border-radius: var(--border-radius);\n  font-type: monospace;\n"], ["\n  background: var(--brand-lightest);\n  padding: calc(var(--spacing) * 0.5) calc(var(--spacing));\n  border-radius: var(--border-radius);\n  font-type: monospace;\n"])));
export default (function (props) {
    return _jsx(Root, { children: props.children });
});
var templateObject_1;
//# sourceMappingURL=index.js.map